import { createGlobalStyle } from 'styled-components'
import { normalize } from 'polished'
import { PALETTE_COLOR as Color } from '../../constants/app.constant'

const GlobalStyle = createGlobalStyle`
  ${normalize() as any}

  *, *:before, *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: -apple-system,BlinkMacSystemFont,"Hiragino Sans","Helvetica Neue",Roboto,sans-serif;
    color: ${Color.BLACK};
  }

  /* TODO: custom globalstyle eg. font-family */
  p {
    font-size: 12px;
  }
  ul,li {
    list-style-type: none;
  }
  img {
    vertical-align: middle;
  }
`

export default GlobalStyle



// WEBPACK FOOTER //
// ./src/components/utils/globalstyle.ts